import { render, staticRenderFns } from "./ModalConsolidarLotePssc.vue?vue&type=template&id=887d5c5c&lang=pug"
import script from "./ModalConsolidarLotePssc.vue?vue&type=script&lang=js"
export * from "./ModalConsolidarLotePssc.vue?vue&type=script&lang=js"
import style0 from "./ModalConsolidarLotePssc.vue?vue&type=style&index=0&id=887d5c5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports